import styled from '@emotion/styled';

import { createElement, MouseEvent, ReactNode, useState } from 'react';

import { useDispatch } from 'react-redux';

import { CartWhite45 } from '../../../images';
import RestockNotificationModal from '../../Restock/RestockNotificationModal';
import {
  getCartProduct,
} from '../../../../mypage/order/shared/services/cart.service';
import { notify } from '../../../reducers/page';
import { ContentsProduct } from '../../../../mypage/order/shared/interfaces';
import DialogCart from '../../Cart/DialogCart';
import { ProductStatusCode } from '../../../interfaces';

const Button = styled.button`
  position: absolute;
`;

function PreventEventBubbling({ children }: { children: ReactNode; }) {
  return createElement('div', {
    onClick: (e) => e.stopPropagation(),
  }, children);
}

interface Props {
  code: ProductStatusCode;
  isGroupProduct: boolean;
  canRestockNotify: boolean;
  contentProductNo: number;
  isBuyNow: boolean;
  className?: string;
  queryId?: string;
  deliveryTypeNames: string[];
  onSelectProductShortcut?(): void;
  selectMainShortcut?(): void;
}

export default function ProductCardFunction({
  code, isGroupProduct, canRestockNotify, contentProductNo, isBuyNow, className,
  queryId, deliveryTypeNames,
  onSelectProductShortcut, selectMainShortcut,
}: Props) {
  const [restockModalOpen, setRestockModalOpen] = useState(false);
  const [cartShortcutOpen, setCartShortcutOpen] = useState(false);
  const [productData, setProductData] = useState<ContentsProduct>();
  const cartShortcutEnabled = code === 'PURCHASABLE' && !isGroupProduct && !isBuyNow;
  const isSoldOut = code === 'SOLD_OUT';

  const dispatch = useDispatch();

  const openCartDialog = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setCartShortcutOpen(true);

    if (onSelectProductShortcut) {
      onSelectProductShortcut();
    }

    if (selectMainShortcut) {
      selectMainShortcut();
    }
  };

  if (cartShortcutEnabled) {
    return (
      <PreventEventBubbling>
        {cartShortcutOpen &&
          <DialogCart
            open={cartShortcutOpen}
            productCode={contentProductNo.toString()}
            onHandleClose={() => setCartShortcutOpen(false)}
            deliveryTypeNames={deliveryTypeNames}
            queryId={queryId}
          />
        }
        <Button
          type="button"
          className={className}
          onClick={openCartDialog}
        >
          <img
            src={CartWhite45}
            alt={'장바구니 아이콘'}
          />
        </Button>
      </PreventEventBubbling>
    );
  }

  const openRestockModal = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      setRestockModalOpen(true);

      if (productData) {
        return;
      }

      const product = await getCartProduct(contentProductNo);
      setProductData(product);
    } catch (err) {
      dispatch(notify('구매할 수 없는 상품입니다.'));
      setRestockModalOpen(false);
    }
  };

  if (isSoldOut) {
    return (
      <PreventEventBubbling>
        <RestockNotificationModal
          productData={productData}
          name={productData?.name}
          contentProductNo={contentProductNo}
          deals={productData?.dealProducts || []}
          open={restockModalOpen}
          deliveryTypeNames={deliveryTypeNames}
          queryId={queryId}
          closeModal={() => setRestockModalOpen(false)}
        />
        <Button
          type="button"
          className={className}
          onClick={openRestockModal}
          disabled={!canRestockNotify}
        >
          <img
            src={
              canRestockNotify
                ? 'https://res.kurly.com/pc/ico/2010/ico_bell_on.svg'
                : 'https://res.kurly.com/pc/ico/2010/ico_bell.svg'
            }
            alt="재입고 알림 아이콘"
          />
        </Button>
      </PreventEventBubbling>
    );
  }

  return null;
}
